console.log("Hello from KfxLanguageSwitcher!");